/** Alfred's presence: a glowing ring that breathes while idle and pulses while thinking. */
export function Orb({
  state,
  size = 'large',
}: {
  state: 'idle' | 'thinking';
  size?: 'large' | 'small';
}) {
  return (
    <div className={`orb orb-${size} orb-${state}`} aria-hidden="true">
      <div className="orb-ring" />
      <div className="orb-core" />
    </div>
  );
}
